export default __webpack_public_path__ + "static/media/assessments.4ca63e7a.svg";